export const CORE_SEAT = 'CORE_SEAT';
export const SALES_SEAT = 'SALES_SEAT';
export const SERVICE_SEAT = 'SERVICE_SEAT';
export const COMMERCE_SEAT = 'COMMERCE_SEAT';
export const CONTACTS = 'CONTACTS';
export const EMAIL_SENDS = 'EMAIL_SENDS';
export const BREEZE_INTELLIGENCE_TOKENS = 'BREEZE_INTELLIGENCE_TOKENS';
export const BREEZE_INTELLIGENCE_CREDITS = 'BREEZE_INTELLIGENCE_CREDITS';
export const HUBSPOT_CREDITS = 'HUBSPOT_CREDITS';